import { useState } from 'react';
import { generateRandomSlug } from '@stigg-common';

// this hook can be removed when we upgrade to react 18 as it has a built-in useId hook
export function useId() {
  const [id] = useState<string>(generateRandomSlug());
  return id;
}
